import { render, staticRenderFns } from "./VirtualMachineAdd.vue?vue&type=template&id=0b646daf&"
import script from "./VirtualMachineAdd.vue?vue&type=script&lang=js&"
export * from "./VirtualMachineAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports